/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export class BaseValidator {
	constructor() {
	}

	name(model) {
		return "Validator"
	}

	logic(x, model, data) {
		return true;
	}
	
	className() {
		return null;
	}

	message(model) {
		return "";
	}

	show(editMode) {
		return !!editMode;
	}
}
